function NoteContent({text, date, title, status, updateDate}) {
  return (
    <div className={`note-container note-${status}`}>
      {title && <h3 className="note-title">{title}</h3>}
      <span className="note-text">{text}</span>
      <span className="note-date">Created:{date}</span>
      {updateDate && <span className="note-date">Updated: {updateDate}</span>}
    </div>
  );
}

export default NoteContent;